// ./src/components/features/CalendarStartDaySelector/CalendarStartDaySelector.tsx
import React, { useEffect } from "react";
import { Select, SelectProps } from "@mantine/core";

const CALENDAR_START_DAY_OPTIONS = [
  { value: "0", label: "Sunday", disabled: false },
  { value: "1", label: "Monday", disabled: false },
];

export interface CalendarStartDaySelectorProps
  extends Omit<SelectProps, "data" | "value" | "onChange"> {
  /** Current status value (100 for enabled, 0 for disabled) */
  value: string | null | undefined;

  /** Callback when status changes */
  onChange: (value: string | null | undefined) => void;

  required?: boolean;
}

export const CalendarStartDaySelector: React.FC<
  CalendarStartDaySelectorProps
> = ({
  value,
  onChange,
  required,
  placeholder = "Select display type",
  ...selectProps
}) => {
  // Convert numeric value to string for Select component
  const stringValue = value !== null ? String(value) : null;

  // Prepare select data with optional descriptions
  const selectData = CALENDAR_START_DAY_OPTIONS.map((option: any) => {
    let label: string = option.label;

    return {
      value: option.value,
      label,
      disabled: option.disabled,
    };
  });

  // Auto-select first display type if required and no value is set
  useEffect(() => {
    if (required && value == null && onChange) {
      const firstOption = CALENDAR_START_DAY_OPTIONS[0];
      if (firstOption && !firstOption.disabled) {
        onChange(firstOption.value);
      }
    }
  }, [required, value, onChange]);

  // Handle change and convert back to number
  const handleChange = (stringValue: string | null) => {
    if (stringValue === null) {
      onChange(null);
    } else {
      onChange(stringValue);
    }
  };

  return (
    <Select
      {...selectProps}
      data={selectData}
      value={stringValue}
      onChange={handleChange}
      placeholder={placeholder}
      clearable={!required}
      required={required}
      allowDeselect={!required}
      withAsterisk={required}
      size="md"
    />
  );
};

// Export status options for use in other components
export { CALENDAR_START_DAY_OPTIONS };
